import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./store/store";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

serviceWorker.unregister();
